import React from 'react'
import PropTypes from 'prop-types'

import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Mask from '../../assets/images/about-us/mask-sm.svg'
import MaskH from '../../assets/images/about-us/mask-sm-h.svg'

function CompanyCard({ secondary, data }) {
  return (
    <div className="company-card">
      <GatsbyImage
        className="company-card__img"
        image={getImage(data.profilePicture.image)}
        alt={data.fullName}
      />

      <img className="company-card__mask" src={Mask} alt="The company card mask " />
      <img className="company-card__mask_h" src={MaskH} alt="The company card mask bigger" />
      <div className="company-card__text-box">
        {!data.blurb || !data.blurb.trim().length ? ( // no blurb
          <p className="company-card__heading-noblurb">
            <strong>{data.fullName}</strong>, <br />
            {data.position}
          </p>
        ) : (
          // has blurb
          <>
            <p className="company-card__heading">
              <strong>{data.fullName}</strong>, {data.position}
            </p>
            <p className={`company-card__text${secondary ? ' company-card__text--sub' : ''}`}>
              {data.blurb}
            </p>
          </>
        )}
      </div>
    </div>
  )
}

CompanyCard.defaultProps = {
  secondary: false
}

CompanyCard.propTypes = {
  data: PropTypes.object.isRequired,
  secondary: PropTypes.bool
}

export default CompanyCard
